const SwitchView = {
  catalogSwitchGrid: null,
  catalogSwitchList: null,
  catalogBody: null,

  init() {
    this.catalogSwitchGrid = document.querySelector('.switch-catalog__item--grid');
    this.catalogSwitchList = document.querySelector('.switch-catalog__item--list');
    this.catalogBody = document.querySelector('.catalog-lvl-three__body');

    if (!this.catalogBody) return;

    const switchType = window.localStorage.getItem('catalogSwitch');
    if (switchType === 'list') {
      if (this.catalogSwitchList) this.catalogSwitchList.classList.add('selected');
      this.catalogBody.classList.remove('catalog-lvl-three__body--grid');
      this.catalogBody.classList.remove('hidden');
    } else {
      if (this.catalogSwitchGrid) this.catalogSwitchGrid.classList.add('selected');
      this.catalogBody.classList.add('catalog-lvl-three__body--grid');
      this.catalogBody.classList.remove('hidden');
    }

    this.cardChange();
    this.addClickHandler();
  },

  addClickHandler() {
    if (this.catalogSwitchList) {
      this.catalogSwitchList.addEventListener('click', () => {
        this.catalogSwitchList.classList.add('selected');
        this.catalogSwitchGrid.classList.remove('selected');
        window.localStorage.setItem('catalogSwitch', 'list');
        if (this.catalogBody.classList.contains('catalog-lvl-three__body--grid')) {
          this.catalogBody.classList.remove('catalog-lvl-three__body--grid');
          this.cardChange();
        }
      });
    }

    if (this.catalogSwitchGrid) {
      this.catalogSwitchGrid.addEventListener('click', () => {
        this.catalogSwitchList.classList.remove('selected');
        this.catalogSwitchGrid.classList.add('selected');
        window.localStorage.setItem('catalogSwitch', 'grid');
        this.catalogBody.classList.add('catalog-lvl-three__body--grid');
        this.cardChange();
      });
    }
  },

  cardChange() {
    const productCards = document.querySelectorAll('.product-card');

    productCards.forEach((card) => {
      card.classList.add('product-card--row');
      if (this.catalogBody.classList.contains('catalog-lvl-three__body--grid')) {
        card.classList.remove('product-card--row');
      }
    });
  },
};

SwitchView.init();
window.SwitchView = SwitchView;
